export interface StandardBoks {
    tittel: string;
    tekst: string;
}

export const PLANNIVA_STANDARDBOKSER: StandardBoks[] = [
    {
        tittel: 'Hva kan bygges på tomta?',
        tekst: 'På tomta tillates det bygging av frittliggende småhusbebyggelse [eller] konsentrert småhusbebyggelse [eller] fritidsbebyggelse.',
    },
    {
        tittel: 'Hvor kan det bygges på tomta?',
        tekst: 'Bebyggelsen skal plasseres innenfor byggegrense som kommer frem i plankartet. [Eventuell annen relevant informasjon. F.eks. garasjer kan plasseres inntil nabogrense og inntil 1 meter fra formålsgrensen mot vegformål, dersom innkjøring er parallelt med veien.]',
    },
    {
        tittel: 'Hvor mye kan bygges på tomta?',
        tekst: 'Utnyttelsesgraden [BYA/BRA] er på [..%]. Dette betyr at [..%] av tomtens totale areal kan bygges ut. Det som inngår i [%BYA/BRA] er husets [fotavtrykk, veranda, balkong, garasje, uthus, etc.]',
    },
    {
        tittel: 'Hvor høyt kan det bygges?',
        tekst: 'Maksimal gesimshøyde er [.. meter] og maksimal mønehøyde er [.. meter] [evt. målt fra gjennomsnittlig planert terreng etc.]',
    },
];
